var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1582.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Unlock",
    transform: "translate(445.000000, 1582.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,5.406 L26.997,8 L23.998,8 L24,5.406 C24,4.079 22.921,3 21.594,3 L10.406,3 C9.079,3 8,4.079 8,5.406 L8,13 L5,13 L5,5.406 C5,2.425 7.425,0 10.406,0 L21.594,0 C24.575,0 27,2.425 27,5.406 L27,5.406 Z M17.364,23.567 L17.364,25.97 C17.364,26.662 16.804,27.221 16.114,27.221 C15.423,27.221 14.863,26.662 14.863,25.97 L14.863,23.567 C14.192,23.149 13.745,22.405 13.745,21.555 C13.745,20.248 14.806,19.187 16.114,19.187 C17.422,19.187 18.482,20.248 18.482,21.555 C18.482,22.405 18.035,23.149 17.364,23.567 L17.364,23.567 Z M4,15 L4,32 L24.972,32 C26.645,32 28,30.534 28,28.727 L28,15 L4,15 Z",
    id: 160
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionUnlock);
export default __webpack_public_path__ + "static/media/navigation-and-action-unlock.0e33c048.svg";
export { ForwardRef as ReactComponent };